import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";

@Injectable({
  providedIn: "root"
})
export class PruHttpService {
  standardHeaders: any;
  csrHeaders: any;
  constructor(private http: HttpClient, private _cookieService: CookieService) {
    this.standardHeaders = {
      "Content-Type": "application/json",
      "X-PruRequestID": "WCF_" + this.getRequestId(),
      "Cache-Control": "no-cache",
      "Pragma": "no-cache",
      "Expires": "Sat, 01 Jan 2000 00:00:00 GMT"
    };
    this.csrHeaders = this.getImpersonatedId() ? { "X-PruImpersonatedIdentity": this.getImpersonatedId()} : null;
  }

  getRequestId() {
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
      requestID = "";
    for (let i = 0; i < 10; i++) {
      requestID += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return requestID;
  }

  getImpersonatedId() {
    /*** start for local dev uncomment***/
    // return /(csr|localhost)/.test(location.host) &&
    /*** end for local dev uncomment***/
    if (/csr/.test(location.host) && this._cookieService.get("X-PruImpersonatedIdentity")) {
      this._cookieService.set("X-PruBU-RET-UserType", 'I', null, '/', '.prudential.com', true);
      return this._cookieService.get("X-PruImpersonatedIdentity");
    }
    return null;
  }

  setHeaders(componentId: string, customisedHeaders?: any) {
    let result = Object.assign(
      { "X-PruComponentID": componentId },
      this.standardHeaders,
      this.csrHeaders,
      customisedHeaders
    );
    return result;
  }

  get(url: string, componentId: string, pars?: any, customHeaders?: any) {
    let heads = new HttpHeaders(this.setHeaders(componentId, customHeaders));
    return this.http.get(url, { headers: heads, params: pars });
  }

  getFullResponse(url: string, componentId: string, pars?: any, customHeaders?: any) {
    let heads = new HttpHeaders(this.setHeaders(componentId, customHeaders));
    return this.http.get(url, { headers: heads, params: pars, observe: 'response' });
  }

  getWcmContent(url: string) {
    return this.http.get(url);
  }

  delete(url: string, componentId: string, pars?: any, customHeaders?: any) {
    let heads = new HttpHeaders(this.setHeaders(componentId, customHeaders));
    return this.http.delete(url, { headers: heads, params: pars });
  }

  post(url: string, componentId: string, data?: any, customHeaders?: any) {
    let heads = new HttpHeaders(this.setHeaders(componentId, customHeaders));
    return this.http.post(url, data, { headers: heads });
  }

  put(url: string, componentId: string, data?: any, customHeaders?: any) {
    let heads = new HttpHeaders(this.setHeaders(componentId, customHeaders));
    return this.http.put(url, data, { headers: heads });
  }

  getText(
    url: string,
    componentId: string,
    par?: any,
    customHeaders?: any
  ): Observable<any> {
    let heads = new HttpHeaders(this.setHeaders(componentId, customHeaders));
    if (par === "no-headers") {
      return this.http.get(url, { responseType: "text" });
    } else {
      return this.http.get(url, {
        headers: heads,
        params: par,
        responseType: "text"
      });
    }
  }
}